const Portfolio = () => {
  return (
    <>
      {/* <!-- ====================================== Section Portfolio ===================================== --> */}
      <section className="portfolio-section" id="portfolio">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Portfolio.
          </h2>
          <div className="line"></div>
        </div>
        <div className="portfolios-group-main">
          {/* Column 1 */}
          <div>
            <a
              href="https://bright-smile-dental-studio.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Dental-web.mp4"
                    alt="Dental-clinic"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Dental-clinic</p>
                  </div>
                </div>
                <p className="Corporate">Dental-clinic</p>
                <p className="Corporate-sub">React.js+Vite & Tailwind CSS</p>
              </div>
            </a>

            {/* Second row */}

            <a
              href="https://adminkit-demo.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Adminkit-web.mp4"
                    alt="Adminkit-Demo"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Adminkit-Demo</p>
                  </div>
                </div>
                <p className="Corporate">Adminkit-Demo</p>
                <p className="Corporate-sub">React.js & Tailwind CSS</p>
              </div>
            </a>

            {/* Third row */}

            <a
              href="https://amazon-react-clone-six.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Amazon-web.mp4"
                    alt="Amazon clone"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Amazon clone</p>
                  </div>
                </div>
                <p className="Corporate">Amazon clone</p>
                <p className="Corporate-sub">React & Tailwind CSS</p>
              </div>
            </a>

            <a
              href="https://behance-phi.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Behance-web.mp4"
                    alt="Behance.net Clone"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Behance.net Clone</p>
                  </div>
                </div>
                <p className="Corporate">Behance.net Clone</p>
                <p className="Corporate-sub">React.js & Tailwind css</p>
              </div>
            </a>
          </div>

          {/* Column 2 */}
          <div>
            <a
              href="https://zentry-app-sigma.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Zentry-web.mp4"
                    alt="Zentry UI Clone"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Zentry UI Clone</p>
                  </div>
                </div>
                <p className="Corporate">Zentry UI Clone</p>
                <p className="Corporate-sub">React.js,Gsap & Tailwind CSS</p>
              </div>
            </a>

            {/* Row-2 */}

            <a
              href="https://spylt-app.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/spylt-video.mp4"
                    alt="Spylt-clone"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Spylt clone</p>
                  </div>
                </div>
                <p className="Corporate">Spylt clone</p>
                <p className="Corporate-sub">React.js,Gsap & Tailwind CSS</p>
              </div>
            </a>

            <a
              href="https://apple-replica-sigma.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Apple-web.mp4"
                    alt="Apple.com Clone"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Apple.com Clone</p>
                  </div>
                </div>
                <p className="Corporate">Apple.com Clone</p>
                <p className="Corporate-sub">Tailwind CSS + React.js</p>
              </div>
            </a>

            <a
              href="https://paheli-cyber-security.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Paheli-web.mp4"
                    alt="Paheli Cyber Security"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Paheli Cyber Security</p>
                  </div>
                </div>
                <p className="Corporate">Paheli Cyber Security</p>
                <p className="Corporate-sub">React.js & Tailwind css</p>
              </div>
            </a>
          </div>

          {/* Column 3 */}
          <div className="gallery-bank-section">
            

            <a
              href="https://crown-tower-realestate-project.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Real-estate.mp4"
                    alt="Real-estate Showcase"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Real-estate Showcase</p>
                  </div>
                </div>
                <p className="Corporate">Real-estate Showcase</p>
                <p className="Corporate-sub">React.js + vite ,Framer-motion & Tailwind CSS</p>
              </div>
            </a>



            <a
              href="https://ochi-replica.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/Ochi-web.mp4"
                    alt="Ochi.design"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">Ochi.design</p>
                  </div>
                </div>
                <p className="Corporate">Ochi.design</p>
                <p className="Corporate-sub">React.js,Gsap & Tailwind CSS</p>
              </div>
            </a>
            <a
              href="https://gta-vi-web-lime.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="zoom_in">
                <div className="image-container">
                  <video
                    src="./images/GTA-VI-web.mp4"
                    alt="GTA-VI UI"
                    className="portfolio-video"
                    autoPlay
                    loop
                    muted
                  />
                  <div className="overlay">
                    <p className="overlay-text">GTA-VI UI</p>
                  </div>
                </div>
                <p className="Corporate">GTA-VI UI</p>
                <p className="Corporate-sub">React.js,Gsap & Tailwind CSS</p>
              </div>
            </a>

            
          </div>
        </div>
      </section>

      {/* <!-- ====================================== Section Portfolio End ===================================== --> */}
    </>
  );
};
export default Portfolio;
